/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsSignalComparison,
  AnalyticsSignalComparison$inboundSchema,
} from "./analyticssignalcomparison.js";
import {
  AnalyticsSignalResult,
  AnalyticsSignalResult$inboundSchema,
} from "./analyticssignalresult.js";
import {
  AnalyticsSignalSelection,
  AnalyticsSignalSelection$inboundSchema,
} from "./analyticssignalselection.js";

export type AnalyticsSignalFindings = {
  comparison?: AnalyticsSignalComparison | undefined;
  concentration: { [k: string]: any };
  /**
   * Separate same_message and same_session joint-answer counts and shares
   */
  cooccurrence: Array<{ [k: string]: any }>;
  /**
   * Permitted recent conversation references without transcript content
   */
  evidence: Array<{ [k: string]: any }>;
  evidenceScope: string;
  measurement: AnalyticsSignalResult;
  peer?: AnalyticsSignalSelection | undefined;
  peerSummary?: { [k: string]: any } | undefined;
};

/** @internal */
export const AnalyticsSignalFindings$inboundSchema: z.ZodMiniType<
  AnalyticsSignalFindings,
  unknown
> = z.pipe(
  z.object({
    comparison: z.optional(AnalyticsSignalComparison$inboundSchema),
    concentration: z.record(z.string(), z.any()),
    cooccurrence: z.array(z.record(z.string(), z.any())),
    evidence: z.array(z.record(z.string(), z.any())),
    evidence_scope: z.string(),
    measurement: AnalyticsSignalResult$inboundSchema,
    peer: z.optional(AnalyticsSignalSelection$inboundSchema),
    peer_summary: z.optional(z.record(z.string(), z.any())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "evidence_scope": "evidenceScope",
      "peer_summary": "peerSummary",
    });
  }),
);

export function analyticsSignalFindingsFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalFindings, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalFindings$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalFindings' from JSON`,
  );
}
